<template>
  <div class='ma-3'>
        <h4>We found the following questions left blank.</h4>
          <v-list-item
        v-for="(item,index) in validation"
        :key="index"
      >
        <v-list-item-avatar>
          <v-icon>
            mdi-information
          </v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>Question for : {{item.title}}</v-list-item-title>

          <v-list-item-subtitle>{{item.question}}</v-list-item-subtitle>
          <v-list-item-subtitle> 
            <v-btn @click.stop="editPerson(item.person)">
            Edit 
          </v-btn></v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          
          <v-btn @click='addUnsureValue(item)'>
            I am not sure.
          </v-btn>
        </v-list-item-action>
      </v-list-item>



        <h3 class="title">Please review all info before submitting</h3>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details></v-text-field>
     
      <v-data-table
        :headers="this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 's' ? mobileHeaders : headers"
        :items="dataModel"
        :search="search"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        item-key="pid"
        show-expand>
        <template v-slot:expanded-item="{ headers,item }">
          <td :colspan="headers.length">
            <br/>

            <div class="mb-2">Relationship to patient: {{ item.relationship }}</div>

            <div class="mb-2">Date of Birth: {{ item.dob }}</div>

            <div class="mb-2">Gender Info:</div>

            <div style="text-indent: 40px" class="mb-2">Sex: {{item.gender}}</div>

            <div
              class="mb-2"
              v-if="item.conditions.length > 0">Conditions:</div>
            <div v-for="(cond,index) in item.conditions" :key='index'>
              <div
                style="text-indent: 40px"
                class="mb-2">
                Condition: {{cond.name}}
              </div>
              <div
                style="text-indent: 40px"
                class="mb-2">
                Age diagnosed: {{cond.age}}
              </div>
              <div
                style="text-indent: 40px"
                class="mb-2">
                Details: {{cond.details}}
              </div>
            </div>

            <div class="mb-2">Living: {{ item.isLiving }}</div>

            <div
              v-if="item.notes !== ''"
              class="mb-2">Notes: {{ item.notes }}</div>
          </td>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            small
            @click.stop="editPerson(item)">
            edit
          </v-icon>
        </template>
      </v-data-table>
  
    <v-dialog
      v-model="personModal"
      persistent
      scrollable
      width="500">
      <personDetailForm
        :data='dataModel'
        v-on:closePersonModal="personModalClose"
        :indexNum='personIndex'/>
    </v-dialog>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import personDetailForm from "../PatientFormComp/PersonDetailForm"

export default {
  components: {
    personDetailForm,
  },
  data () {
    return {
      validation : [],
      expanded: [],
      singleExpand: true,
      headers: [
        { text: 'Name', align: 'left', value: 'name' },
        { text: 'Relationship', align: 'right', value: 'relationship' },
        { text: 'Action', align: 'right', value: 'action', sortable: false },
				{ value: 'data-table-expand' }
      ],
			mobileHeaders: [
        { text: 'Name', value: 'name' },
        { value: 'action', align: 'start', sortable: false },
				{ value: 'data-table-expand', align: 'end' }
			],
      active: [],
      search: null,
      caseSensitive: false,
      personIndex: null,
      personModal: false,
      loading: null,
      panel: [],
      gsflogo: "",
      nameList: [],
      tableSettings: { rowsPerPage: -1 }
    };
  },
  mounted () {
    this.checkFields();
		if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 's') {
			this.headers = [
        { text: 'Name', value: 'name' },
        { value: 'action', align: 'start', sortable: false },
				{ value: 'data-table-expand', align: 'end' }
			]
		}
  },

  computed: {
    selected () {
      if (!this.active.length) return undefined
      const id = this.active[0]
      return this.dataModel.find(person => person.name === id)
    },
    filter () {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined
    },
    ...mapFields("patientQuestion", ["dataModel", "formID"])
  },
  methods: {
    addUnsureValue(element){
      let person = this.dataModel.find(p => p.pid === element.id);
      person.notes +=  "\nuser is not sure about question :" + element.question;
      person[element.subtitle] = null;
       this.personModal = false
      this.checkFields()
    },
    personModalClose(){
      this.personModal = false
      this.checkFields()
    },
    // check to see if any fields in the data model array is empty
    checkFields(){
      this.validation = [];
      this.dataModel.forEach(element => {
        for (const property in element) {
          if(element[property] === ""){
            switch (property){
              case "notes":
              case "death":
              case "halfSib":
              break;
              default :
              this.validation.push({
              title: element.name,
              question : this.genQuestion(property),
              subtitle : property,
              id : element.pid,
              person : element
            })
            break;
            }
            
           
          }
  
}
      });
    },
    genQuestion(property){
      switch (property){
        case "death":
        return "currently living?";
        case "isgeneticTest":
        return "Has this relative had genetic testing for a health condition that you know of?";
        case "dob":
        return "Date of Birth";
        case "isHalf" :
        return "Is this person a half sibling?";
        case "halfSib" :
        return "What kind of half sibling?";
        default : 
        return property;
      }
    },
    getItem () {
      var patient = this.dataModel.find(person => { return person.relationship === "self" })
      var tempItem = [{        name: patient.name + "'s family",
        children: this.dataModel.filter(item => { return item }).map(x => { return { name: x.name } })
      }]
      return tempItem
    },
    editPerson (data) {
      this.personIndex = this.dataModel.findIndex(person => person.pid === data.pid)
      this.personModal = true
    },



    all () {
      this.panel = [...Array(this.dataModel.length).keys()].map(() => true);
    },
    none () {
      this.panel = [];
    },
    relationshipViewFormat (person) {
      if (person.relationship === "self") {
        return "patient";
      }
      if (
        person.relationship === "child" &&
        (person.gender === "Male" || person.gender === "Transgender Male")
      ) {
        return "patient's son";
      } else if (
        person.relationship === "child" &&
        (person.gender === "Female" || person.gender === "Transgender Female")
      ) {
        return "patient's daughter";
      } else if (
        person.relationship === "child" &&
        person.gender === "Other"
      ) {
        return "patient's child";
      }
      if (
        person.relationship === "sibling" &&
        (person.gender === "Male" || person.gender === "Transgender Male")
      ) {
        return "patient's brother";
      } else if (
        person.relationship === "sibling" &&
        (person.gender === "Female" || person.gender === "Transgender Female")
      ) {
        return "patient's sister";
      } else if (
        person.relationship === "sibling" &&
        person.gender === "Other"
      ) {
        return "patient's sibling";
      } else {
        return person.relationship;
      }
    },
    readableTrueFalse (item) {
      if (item === true) {
        return "Yes";
      } else {
        return "No";
      }
    }
  }
};
</script>

<style scoped>
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
